import type { z } from "zod";

export type Parser<S extends z.ZodType> = {
  readonly schema: S;
  parse(v: unknown): z.infer<S>;
  safeParse(v: unknown): z.ZodSafeParseResult<z.infer<S>>;
  is(v: unknown): v is z.infer<S>;
};

export function parser<S extends z.ZodType>(schema: S): Parser<S> {
  return Object.freeze({
    schema,
    parse(v: unknown) {
      return this.schema.parse(v);
    },
    safeParse(v: unknown) {
      return this.schema.safeParse(v);
    },
    // TODO: this is also in zod-utils if memory serves.
    is(v: unknown): v is z.infer<S> {
      return this.safeParse(v).success;
    },
  });
}

export type ParserType<P extends Parser<z.ZodType>> = z.infer<P["schema"]>;
export type ParserSchema<P extends Parser<z.ZodType>> = P["schema"];
